import type { ILanguageResources, ITranslationModule } from '../../../../../interfaces';
import { interpolate } from '../../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.quotes.views.v6.FranchiseeV6BomViewer.';

  public static readonly close = `${Id.prefix}close`;
  public static readonly export = `${Id.prefix}export`;
  public static readonly errorConvertingToCsv = `${Id.prefix}errorConvertingToCsv`;
  public static readonly bomViewTitle = `${Id.prefix}bomViewTitle`;
  public static readonly noBomDataForQuoteItem = `${Id.prefix}noBomDataForQuoteItem`;
}

export class LangFranchiseeV6BomViewer {
  private constructor() {}

  public static close(): string {
    return interpolate(Id.close);
  }
  public static export(): string {
    return interpolate(Id.export);
  }
  public static errorConvertingToCsv(): string {
    return interpolate(Id.errorConvertingToCsv);
  }
  public static bomViewTitle(params: { title: string }): string {
    return interpolate(Id.bomViewTitle, params);
  }
  public static noBomDataForQuoteItem(): string {
    return interpolate(Id.noBomDataForQuoteItem);
  }
}

export class FranchiseeV6BomViewerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.close, 'Close', 'Button label for closing the BOM viewer');
    register.add(Id.export, 'Export', 'Button label for exporting BOM data');
    register.add(Id.errorConvertingToCsv, 'Error converting to CSV', 'Error message when CSV conversion fails');
    register.add(Id.bomViewTitle, 'BOM View ({{title}})', 'Title for the BOM viewer dialog');
    register.add(
      Id.noBomDataForQuoteItem,
      "There is no BOM related data for this {{glossary 'quote-item'}}. Try resaving the item to generate BOM",
      'Message when there is no BOM data for the quote item'
    );
  }
}
